import * as React from 'react';
import { BLACKS_AND_WHITES, STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';

export const getStatusDisplayName = (status: string): string => {
	switch (status) {
		case 'Pending':
			return 'Requested';
		case 'Open':
			return 'Open';
		case 'Deferred':
			return 'Deferred';
		case 'InProgress':
			return 'In Progress';
		case 'OnHold':
			return 'On Hold';
		case 'Completed':
			return 'Completed';
		case 'Cancelled':
			return 'Cancelled';
		default:
			return 'Unknown';
	}
};

const WorkOrderDisplayStatusDisplay = ({
	status,
	darkMode = false,
	style = {},
	textStyle = {},
	...props
}) => {
	let statusColor;
	let statusBackgroundColor;

	switch (status) {
		case 'Pending':
			statusColor = '#4a1e87';
			statusBackgroundColor = '#e8def8';
			break;
		case 'Open':
			statusColor = STOPLIGHT_COLORS.pureRed;
			statusBackgroundColor = '#f9e6e6';
			break;
		case 'Deferred':
			statusColor = 'rgb(213, 125, 5)';
			statusBackgroundColor = 'rgb(254, 234, 205)';
			break;
		case 'InProgress':
			statusColor = 'rgb(11, 28, 111)';
			statusBackgroundColor = 'rgb(225, 229, 249)';
			break;
		case 'OnHold':
			statusColor = 'rgb(137, 107, 12)';
			statusBackgroundColor = '#fcf3d9';
			break;
		case 'Completed':
			statusColor = STOPLIGHT_COLORS.pureGreen;
			statusBackgroundColor = '#e6f9e7';
			break;
		case 'Cancelled':
			statusColor = BLACKS_AND_WHITES.blackPrimary;
			statusBackgroundColor = '#f2f2f2';
			break;
		default:
			statusColor = BLACKS_AND_WHITES.blackPrimary;
			statusBackgroundColor = '#f2f2f2';
	}

	if (darkMode) {
		statusColor = BLACKS_AND_WHITES.whiteSecondary;
	}

	const statusDisplayName = getStatusDisplayName(status);

	return (
		<span
			{...props}
			style={{
				display: 'flex',
				flexWrap: 'nowrap',
				whiteSpace: 'nowrap',
				color: statusColor,
				background: statusBackgroundColor,
				padding: '4px 12px',
				borderRadius: 16,
				...style,
				...textStyle,
			}}
		>
			{statusDisplayName}
		</span>
	);
};
export default WorkOrderDisplayStatusDisplay;
